import { render, staticRenderFns } from "./OrgTree.vue?vue&type=template&id=90fa6df6&scoped=true&"
import script from "./OrgTree.vue?vue&type=script&lang=js&"
export * from "./OrgTree.vue?vue&type=script&lang=js&"
import style0 from "./OrgTree.vue?vue&type=style&index=0&id=90fa6df6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fa6df6",
  null
  
)

component.options.__file = "OrgTree.vue"
export default component.exports